module.exports = __webpack_public_path__ + "static/image11@2x-05402cb0eebaa37f44c70cbf7dcdc15f.png";